export type AppHeaderConfig = {
  backTo: string;
  backLabel: string;
  backReplace?: boolean;
  backSource?: "route-state" | "receipt" | "plans";
};

const exactRoutes: Record<string, AppHeaderConfig> = {
  "/talk": { backTo: "/home", backLabel: "ホームへ戻る" },
  "/chat": { backTo: "/home", backLabel: "ホームへ戻る" },
  "/talk/group": { backTo: "/home", backLabel: "ホームへ戻る" },
  "/talk/group/preview": { backTo: "/talk/group", backLabel: "AI壁打ちへ戻る" },
  "/talk/group/sessions": { backTo: "/talk/group", backLabel: "AI壁打ちへ戻る" },
  "/request": { backTo: "/home", backLabel: "ホームへ戻る" },
  "/request/company-research": { backTo: "/request", backLabel: "調べてもらうへ戻る" },
  "/request/company-research/jobs": { backTo: "/request/company-research", backLabel: "企業リサーチへ戻る" },
  "/request/knowledge": { backTo: "/home", backLabel: "ホームへ戻る" },
  "/request/executive-memos": { backTo: "/home", backLabel: "ホームへ戻る" },
  "/request/news": {
    backTo: "/request",
    backLabel: "前の画面へ戻る",
    backReplace: true,
    backSource: "route-state",
  },
  "/request/schedules": {
    backTo: "/request/news",
    backLabel: "ニュースへ戻る",
    backSource: "route-state",
  },
  "/executive-memos": {
    backTo: "/home",
    backLabel: "前の画面へ戻る",
    backSource: "route-state",
  },
  "/receipt": {
    backTo: "/home",
    backLabel: "前の画面へ戻る",
    backReplace: true,
    backSource: "receipt",
  },
  "/receipt/history": { backTo: "/receipt", backLabel: "領収書整理へ戻る" },
  "/profile": {
    backTo: "/home",
    backLabel: "前の画面へ戻る",
    backReplace: true,
    backSource: "route-state",
  },
  "/profile/login-methods": {
    backTo: "/home",
    backLabel: "前の画面へ戻る",
    backSource: "route-state",
  },
  "/character-switch": { backTo: "/home", backLabel: "ホームへ戻る" },
  "/request/deep-report": { backTo: "/request", backLabel: "調べてもらうへ戻る" },
  "/reports": { backTo: "/request", backLabel: "調べてもらうへ戻る" },
  "/plans": {
    backTo: "/home",
    backLabel: "前の画面へ戻る",
    backSource: "plans",
  },
  "/support-inquiry": {
    backTo: "/home",
    backLabel: "前の画面へ戻る",
    backSource: "route-state",
  },
};

export function readRouteStateReturnTo(state: unknown): string | null {
  if (!state || typeof state !== "object") return null;
  const value = (state as { returnTo?: unknown }).returnTo;
  if (typeof value !== "string") return null;
  for (let index = 0; index < value.length; index += 1) {
    const characterCode = value.charCodeAt(index);
    if (value[index] === "\\" || characterCode <= 0x1f || characterCode === 0x7f) {
      return null;
    }
  }
  const path = value.trim();
  if (!path.startsWith("/") || path.startsWith("//")) return null;
  return path;
}

export function resolveRouteStateReturnTo(state: unknown, fallback: string): string {
  return readRouteStateReturnTo(state) ?? fallback;
}

export function resolveAppHeaderConfig(pathname: string): AppHeaderConfig | null {
  const exact = exactRoutes[pathname];
  if (exact) return exact;
  if (/^\/talk\/group\/sessions\/[^/]+$/.test(pathname)) {
    return { backTo: "/talk/group", backLabel: "AI壁打ちへ戻る" };
  }
  if (/^\/request\/company-research\/jobs\/[^/]+$/.test(pathname)) {
    return { backTo: "/request/company-research", backLabel: "企業リサーチへ戻る" };
  }
  if (/^\/request\/knowledge\/[^/]+$/.test(pathname)) {
    return { backTo: "/request/knowledge", backLabel: "前の画面へ戻る", backSource: "route-state" };
  }
  if (/^\/executive-memos\/[^/]+$/.test(pathname)) {
    return { backTo: "/executive-memos", backLabel: "社長メモ一覧へ戻る" };
  }
  if (/^\/receipt\/[^/]+$/.test(pathname)) {
    return { backTo: "/receipt/history", backLabel: "領収書の記録へ戻る" };
  }
  if (/^\/reports\/[^/]+$/.test(pathname)) {
    return { backTo: "/reports", backLabel: "レポート一覧へ戻る" };
  }
  return null;
}
